export default __webpack_public_path__ + "static/media/regulatory--bicycles-yield-or-use-signal--g1.1f65e157.png";